import React, { useState, useContext, useReducer } from "react";

import GlobalContext                      from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError                   from "../../isp._comun/servicios/Errores";
import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import ServicioDeQueryDeClientesAFacturar from "../../isp.servicios.clientes/ServicioDeQueryDeClientesAFacturar";
import DialogQueryClientesAFacturar       from "./layouts/DialogQueryClientesAFacturar";
import QueryFactReducer                   from "../reductores/QueryFactReducer";
import CargaDeClientesBuscados            from "../reductores/acciones/dispatch/CargaDeClientesBuscados";
import FinalizarComando                   from "../reductores/acciones/dispatch/FinalizarComando";


// import { NotificacionToastDeError } from "../../../all/componentes/widgets/Notificaciones";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

// import ServicioDeQueryDeUnClienteAFacturar from "../../servicios/ServicioDeQueryDeUnClienteAFacturar";

const DialogoInteractivoDeQueryClientes = ({ ventana }) => {
    const { notificar } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryFactReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    const buscarClientesAFacturar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
                paramsQuery
            );
            dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    });

    return (
        <DialogQueryClientesAFacturar
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarClientesAFacturar={buscarClientesAFacturar}
        />
    );
};

export default DialogoInteractivoDeQueryClientes;
